export default __webpack_public_path__ + "img/AI-Implementation.9de1ddff.png";